"use client";

import * as React from "react";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GlobalPackagingLandscape() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="227531" id="howwedoit" className="bg-secondary text-secondary-foreground py-24 md:py-32 lg:py-40 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.05] dark:opacity-[0.08]" style={{
      backgroundImage: `linear-gradient(to right, var(--color-primary) 1px, transparent 1px), linear-gradient(to bottom, var(--color-primary) 1px, transparent 1px)`,
      backgroundSize: '4rem 4rem'
    }} aria-hidden="true" />

      <div className="container mx-auto px-6 relative z-10">
        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-12 gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3 flex flex-col items-center">
            
            <Badge variant="default" className="mb-8 uppercase tracking-widest font-mono text-xs px-4 py-1.5 bg-primary text-primary-foreground rounded-none">
              Our Process
            </Badge>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-extrabold text-secondary-foreground uppercase text-center mb-12 tracking-tighter leading-tight">
              Delivering Excellence
            </h2>

            <Separator className="w-full bg-primary h-[2px] mb-12" />

            <div className="w-full space-y-8 text-lg md:text-xl text-secondary-foreground/90 leading-relaxed font-sans text-left">
              <p>
                At Bottom Up Projects, we combine industry-leading project management software with transparent communication to deliver efficient and accountable project outcomes. Our approach prioritises clear reporting, streamlined processes, and active client involvement from the initial planning phase through to final completion. By integrating Software Integration with real-time tracking, we ensure every project milestone is met with precision and technical accuracy.
              </p>
              <p>
                Our commitment to Outcome Delivery means providing high-quality solutions across commercial and industrial fitouts, remedial works, and maintenance. Our experienced team works collaboratively to ensure projects are completed safely, efficiently, and on time. We utilise advanced systems for tracking, reporting, and compliance, ensuring that every site we manage reflects our core values of reliability, safety, and superior workmanship.
              </p>
            </div>

            <Separator className="w-full bg-primary h-[2px] mt-12" />
            
          </div>
        </div>
      </div>
    </section>;
}